export enum ProgressState {
  BEFORE = "before",
  CURRENT = "current",
  AFTER = "after",
}